import { render, staticRenderFns } from "./AttentionAppsReviews.vue?vue&type=template&id=5d121281&scoped=true&lang=pug"
import script from "./AttentionAppsReviews.vue?vue&type=script&lang=js"
export * from "./AttentionAppsReviews.vue?vue&type=script&lang=js"
import style0 from "./AttentionAppsReviews.vue?vue&type=style&index=0&id=5d121281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d121281",
  null
  
)

export default component.exports